// src/modules/app-views/invoices/pages/Init/components/tableColumns/items/itemPisColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import financialService from 'services/financialService';
import { resolveItemFontSize } from './index';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the PIS (social integration contribution) value column for item subtables.
function itemPisColumn(options = {}) {
  const { size, ..._ } = options;
  const fontSize = resolveItemFontSize(size, 10);
  return {
    title: 'PIS',
    dataIndex: ['tax', 'pis', 'value'],
    width: 60,
    align: 'right',
    sorter: (a, b) => {
      const aVal = a?.tax?.pis?.value || a?.pis || 0;
      const bVal = b?.tax?.pis?.value || b?.pis || 0;
      return aVal - bVal;
    },
    render: (_, item) => {
      const pis = item?.tax?.pis?.value || item?.pis;
      if (!pis) {
        return (
          <Text style={{ fontSize }} type="secondary">
            —
          </Text>
        );
      }
      return (
        <Text style={{ fontSize }} type="secondary">
          {financialService.formatCurrency(pis)}
        </Text>
      );
    },
  };
}

export default itemPisColumn;
